<template>
  <div class="promoter-order" ref="container">
    <div class="promoterHeader bg-color-red">
      <div class="headerCon acea-row row-between-wrapper">
        <div>
          <div class="name">累计佣金订单</div>
          <div>
            <span class="num">{{ count }}</span
            >单
          </div>
        </div>
        <div class="iconfont icon-2"></div>
      </div>
    </div>
    <div class="list">
      <!-- <div class="nav acea-row row-around">
        <div
          class="nav_item"
          :class="where.agentType == 2 ? 'on' : ''"
          @click="changeAgentlist(2)"
        >
          代理订单
        </div>
        <div
          class="nav_item"
          :class="where.agentType == 1 ? 'on' : ''"
          @click="changeAgentlist(1)"
        >
          分销订单
        </div>
      </div> -->
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="title acea-row row-column row-center">
          <div class="data">{{ item.time }}</div>
          <div>本月累计推广订单：{{ item.count ? item.count : 0 }}单</div>
        </div>
        <div class="listn">
          <div class="itenm" v-for="(val, indexn) in item.child" :key="indexn">
            <div class="top acea-row row-between-wrapper">
              <div class="pictxt acea-row row-between-wrapper">
                <div class="pictrue">
                  <img :src="val.avatar" />
                </div>
                <div class="text line1">{{ val.nickname }}</div>
              </div>
              <div class="money">
                <div v-if="val.type === 'pay_money'">暂未返佣</div>
                <div v-else>
                  返佣：<span class="font-color-red"
                    >￥{{ val.number ? val.number : 0 }}</span
                  >
                </div>
              </div>
            </div>
            <div class="bottom">
              <div><span class="name">订单号：</span>{{ val.order_id }}</div>
              <div v-if="val.type === 'pay_money'">
                <span class="name">下单时间：</span>{{ val.time }}
              </div>
              <div v-else>
                <span class="name">返佣时间：</span>{{ val.time }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import { getSpreadOrder } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "PromoterOrder",
  components: {
    Loading,
  },
  props: {},
  data: function () {
    return {
      list: [],
      where: {
        page: 1,
        limit: 15,
        agentType: 2,
      },
      loaded: false,
      loading: false,
      loadTitle: "",
      count: "",
      noAgentlist: [],
      agentlist: [],
    };
  },
  mounted: function () {
    this.getIndex();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getIndex();
    });
  },
  methods: {
    getIndex: function () {
      let that = this;
      if (that.loaded == true || that.loading == true) return;
      that.loading = true;
      getSpreadOrder(that.where).then((res) => {
          if (that.where.agentType == 2) {
            let list = res.data.agent.list
            that.agentlist = that.agentlist.concat(list);
            that.list = that.list.concat(list);
            that.loaded = list.length < that.where.limit;
          } else {
            let list = res.data.district.list
            that.noAgentlist = that.noAgentlist.concat(list);
            that.list = that.list.concat(list);
            that.loaded = list.length < that.where.limit
          }
          that.loading = false;
          that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
          that.where.page = that.where.page + 1;
          that.count = res.data.count;
        },
        (error) => {
          that.$dialog.message(error.msg);
        },
        300
      );
    },
    changeAgentlist: function (val) {
      if(this.loading) return false;
      if (val == 1) this.where.agentType = 1;
      else if (val == 2) this.where.agentType = 2;

      this.where.page = 1;
      this.list = [];
      this.loaded = false;
      this.agentlist = [];
      this.noAgentlist = [];

      this.getIndex();
    },
  },
};
</script>
<style scoped>
.nav {
  background: #ffffff;
}
.nav_item {
  line-height: 3em;
  width: 50%;
  text-align: center;
}
.nav_item.on:after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 3em;
  height: 2px;
  border-radius: 1px;
  background: #c9975c;
}
</style>
